import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AlertCircle } from "lucide-react";

import { AppPageContent } from "@/components/layout/app-page";
import { PageHeader } from "@/components/ui/page-header";
import { TabNav } from "@/components/ui/tab-nav";
import { useCurrentUser, useCurrentCompany } from "@/hooks/use-current-account";

export const Route = createFileRoute("/_authenticated/app/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  const { data: user } = useCurrentUser();
  const { data: company } = useCurrentCompany();

  const profileIncomplete =
    !user?.firstName ||
    !user?.lastName ||
    company?.name === "My Company" ||
    company?.name?.endsWith("'s Company");

  const tabs = [
    { to: "/app/settings", label: "Account" },
    { to: "/app/settings/notifications", label: "Notifications" },
  ] as const;

  return (
    <AppPageContent>
      <PageHeader title="Settings" />

      {profileIncomplete && (
        <div className="mb-8 flex items-center gap-3 rounded-xl border border-destructive/20 bg-destructive/10 p-4 text-destructive">
          <AlertCircle className="h-5 w-5 shrink-0" />
          <div>
            <p className="font-medium">Profile incomplete</p>
            <p className="text-sm opacity-90">Please complete your profile information below.</p>
          </div>
        </div>
      )}

      <TabNav tabs={tabs} variant="full-width" />

      <Outlet />
    </AppPageContent>
  );
}
